import { render, staticRenderFns } from "./NavigationUserMenu.vue?vue&type=template&id=622b1eb5&scoped=true"
import script from "./NavigationUserMenu.vue?vue&type=script&lang=js"
export * from "./NavigationUserMenu.vue?vue&type=script&lang=js"
import style0 from "./NavigationUserMenu.vue?vue&type=style&index=0&id=622b1eb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622b1eb5",
  null
  
)

export default component.exports